


















import Vue from "vue";

// Utils
import iwInlineQuestions from "@/encoding/components/layout/InlineQuestions.vue";

// Questions
import Availability from "./questions/basicInformations/Availability.vue";
import AvailabilityDate from "./questions/basicInformations/AvailabilityDate.vue";
import PropertySubtype from "./questions/basicInformations/PropertySubtype.vue";
import PropertyType from "./questions/basicInformations/PropertyType.vue";
import TransactionType from "./questions/basicInformations/TransactionType.vue";

export default Vue.extend({
    components: {
        iwInlineQuestions: iwInlineQuestions,
        TransactionType: TransactionType,
        PropertyType: PropertyType,
        PropertySubtype: PropertySubtype,
        Availability: Availability,
        AvailabilityDate: AvailabilityDate
    }
});

